<vc-dialog
    [(visible)]="visible"
    [title]="title"
    [width]="width"
    [loading]="loading"
    [primaryLabel]="primaryLabel"
    [secondaryLabel]="secondaryLabel"
    [showPrimary]="showPrimary"
    [primaryDisabled]="primaryDisabled"
    [closeOnPrimary]="closeOnPrimary"
    [closeOnSecondary]="true"
    [actionsOnLeft]="false"
    (primaryTrigger)="onPrimary()"
    (secondaryTrigger)="onSecondary()">
    <div class="vc-multi-file-upload-dialog">
        @if (description) {
            <span class="body-medium">{{ description }}</span>
        }

        <vc-file-upload
            #fileUpload
            [multiple]="multiple"
            [acceptedTypes]="acceptedTypes"
            [maxFileSize]="maxFileSize"
            [fileLimit]="fileLimit"
            [dragFileLabel]="dragFileLabel"
            [selectFilesLabel]="selectFilesLabel"
            [fileTypesLabel]="fileTypesLabel"
            [sizeMaxLabel]="sizeMaxLabel"
            [maxFileSizeError]="maxFileSizeError"
            [fileTypeError]="fileTypeError"
            [uploadingLabel]="uploadingLabel"
            [completeLabel]="completeLabel"
            [uploading]="isUploading"
            [complete]="isComplete"
            [showUploadFilesButton]="!isUploading && !isComplete"
            (uploadsAdded)="onUploadsAdded($event)"
            (selectionChange)="onSelectionChange($event)"
            (uploadTriggered)="onUploadTriggered($event)">
        </vc-file-upload>

        @if (selectionError) {
            <mat-hint class="mat-error vc-error-message">{{ selectionError }}</mat-hint>
        }

        @if (showZipExtractCheckbox) {
            <vc-checkbox [label]="zipExtractLabel" [(checked)]="extractionEnabled"> </vc-checkbox>
        }
    </div>
</vc-dialog>
